// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Island+Moments&family=Pirata+One&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section.num2 {
  position: relative;
  width: 100%;
  height: 110vh;
  background-color: #0a0d16;
  overflow: hidden;
}

.experiencesection-title {
  font-family: 'Pirata One', cursive;
  color: white;
  text-align: center;
  margin: 20px 0;
  font-size: 3rem;
  position: absolute;
  top: 20px;
  width: 100%;
}
/* General container styles */
.experiencecontainer1 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    border-radius: 15px;
    background-color: #121827;
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 150px;
    font-family: Arial, sans-serif;
    overflow: hidden;
    z-index: 5;
    position: absolute;
    top:0;
    height: auto;
    opacity: 98%;
  }
  
  /* Tabs (Work and Project) */
  .experience-tabs {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 20px;
  }
  
  .experience-tab {
    padding: 12px 25px;
    width: 90%;
    border: none;
    background-color: #121827;
    color: #555;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
    border-radius: 5px;
  }
  
  .experience-tab.active {
    background-color: #F4CC00;
    color: #121827;
  }
  
  .experience-tab:hover {
    background-color: #E4B300;
  }
  
  /* Content area */
  .experience-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
  
  /* Vertical tabs */
  .experience-vertical-tabs {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .vertical-tab {
    padding: 12px;
    /* border: 1px solid #73797c; */
    background-color: #121827;
    color: #555;
    text-align: left;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;
    border-radius: 5px;
  }
  
  .vertical-tab.selected {
    background-color: #E4B300;
    color: #121827;
    transform: translateX(5px);
  }
  
  .vertical-tab:hover {
    background-color: #E4B300;
  }
  
  /* Card */
  .experience-card {
    flex: 2 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding: 25px;
    border-radius: 15px;
    background-color: rgb(21, 21, 21);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .experience-card:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  }
  
  .experience-card-image {
    width: 100%;
    max-width: 350px;
    height: auto;
    border-radius: 10px;
    border: 2px solid #E4B300;
  }
  
  .experience-card-title {
    font-size: 24px;
    color: #fff;
    margin: 3px 0;
  }
  
  .experience-card-subtitle {
    font-size: 18px;
    color: #555;
    margin: 1px 0;
  }
  
  .experience-card-description {
    font-size: 16px;
    color: #777;
    text-align: center;
    line-height: 1.5;
  }
  @media (max-width: 768px) {
    .experiencecontainer1{
        top: 50px;
    }
    .experience-content {
      flex-direction: column;
    }
  
    .experience-card {
      width: 100%;
    }
  
    .experience-card-image {
      max-width: 100%;
    }
    .vertical-tab.selected{
        transform: translateX(0);
    }

    .section.num2 {
        height: 160vh;
      }
  }

  /* ship background */
.experiencehome{
    position: relative;
  }
  
  .experiencehome__container{
    padding-top: 9.5rem;
    height: 100vh;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .experiencehome__cloud-1,
  .experiencehome__cloud-2{
    position: absolute;
    width: 150px;
  }
  
  .experiencehome__cloud-1{
    top:6rem;
    right: 1rem;
    animation: cloud-1 8s linear infinite;
  }
  
  .experiencehome__cloud-2{
    top:25rem;
    left: .5rem;
    animation: cloud-2 8s linear infinite;
  }
  
  .experiencehome__images div{
    max-width: initial;
    width: 100%;
    height: 270px;
    background-size: 1000px 100%;
    position: absolute;
    left: 0;
  }
  
  .experiencehome__waves-1{
    bottom: -1.5rem;
    animation: waves-1 4s linear infinite;
  }
  .experiencehome__waves-2{
    bottom: -1rem;
    animation: waves-2 4s linear infinite;
  }
  .experiencehome__waves-3{
    bottom: 3rem;
    animation: waves-3 4s linear infinite;
  }
  .experiencehome__ship{
    width: 45%;
    max-width: 720px;
    min-width: 330px;
    position: absolute;
    bottom: 2rem;
    left: 50;
    right: 0;
    margin-inline: center center;
    animation: ship 2s linear infinite;
  }
  /* Animated Clouds */
  @keyframes cloud-1{
    0%{
      margin-right: -1000px;
    }
    100%{
      margin-right: 100%;
    }
  }
  @keyframes cloud-2{
    0%{
      margin-left: 100%;
    }
    100%{
      margin-left: -1000px;
    }
  }
  
  /* Animated waves */
  @keyframes waves-1{
    0%{
      background-position: 1000px;
    }
    100%{
      background-position: 0;
    }
  }
  
  @keyframes waves-2{
    0%{
      background-position: 0;
    }
    100%{
      background-position: 1000px;
    }
  }
  
  @keyframes waves-3{
    0%{
      background-position: 1000px;
    }
    100%{
      background-position: 0;
    }
  }
  
  /* Animated ship */
  @keyframes ship{
    0%{
      transform: translateY(0) rotate(0);
    }
    25%{
      transform: translateY(0) rotate(-8deg);
    }
    40%{
      transform: translateY(4px) rotate(-8deg);
    }
    85%{
      transform: translateY(1px) rotate(8deg);
    }
    100%{
      transform: translateY(0) rotate(0);
    }
  }
`, "",{"version":3,"sources":["webpack://./src/App/Experience.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA,6BAA6B;AAC7B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,KAAK;IACL,YAAY;IACZ,YAAY;EACd;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,uDAAuD;IACvD,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA,kBAAkB;EAClB;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,+BAA+B;IAC/B,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,4EAA4E;IAC5E,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,SAAS;EACT;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,wCAAwC;IACxC,qDAAqD;EACvD;;EAEA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE;QACI,SAAS;IACb;IACA;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;IACA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;MACf;EACJ;;EAEA,oBAAoB;AACtB;IACI,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,yBAAyB;YAIjB,iBAAiB;EAC3B;;EAEA;;IAEE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,qCAAqC;EACvC;;EAEA;IACE,SAAS;IACT,WAAW;IACX,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,eAAe;IACf,qCAAqC;EACvC;EACA;IACE,aAAa;IACb,qCAAqC;EACvC;EACA;IACE,YAAY;IACZ,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,QAAQ;IACR,4BAA4B;IAC5B,kCAAkC;EACpC;EACA,oBAAoB;EACpB;IACE;MACE,qBAAqB;IACvB;IACA;MACE,kBAAkB;IACpB;EACF;EACA;IACE;MACE,iBAAiB;IACnB;IACA;MACE,oBAAoB;IACtB;EACF;;EAEA,mBAAmB;EACnB;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE;MACE,sBAAsB;IACxB;IACA;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,sBAAsB;IACxB;EACF;;EAEA,kBAAkB;EAClB;IACE;MACE,kCAAkC;IACpC;IACA;MACE,sCAAsC;IACxC;IACA;MACE,wCAAwC;IAC1C;IACA;MACE,uCAAuC;IACzC;IACA;MACE,kCAAkC;IACpC;EACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Island+Moments&family=Pirata+One&display=swap');\r\n\r\n.section.num2 {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 110vh;\r\n  background-color: #0a0d16;\r\n  overflow: hidden;\r\n}\r\n\r\n.experiencesection-title {\r\n  font-family: 'Pirata One', cursive;\r\n  color: white;\r\n  text-align: center;\r\n  margin: 20px 0;\r\n  font-size: 3rem;\r\n  position: absolute;\r\n  top: 20px;\r\n  width: 100%;\r\n}\r\n/* General container styles */\r\n.experiencecontainer1 {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    padding: 20px;\r\n    border-radius: 15px;\r\n    background-color: #121827;\r\n    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    margin-top: 150px;\r\n    font-family: Arial, sans-serif;\r\n    overflow: hidden;\r\n    z-index: 5;\r\n    position: absolute;\r\n    top:0;\r\n    height: auto;\r\n    opacity: 98%;\r\n  }\r\n  \r\n  /* Tabs (Work and Project) */\r\n  .experience-tabs {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 20px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .experience-tab {\r\n    padding: 12px 25px;\r\n    width: 90%;\r\n    border: none;\r\n    background-color: #121827;\r\n    color: #555;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, color 0.3s ease;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .experience-tab.active {\r\n    background-color: #F4CC00;\r\n    color: #121827;\r\n  }\r\n  \r\n  .experience-tab:hover {\r\n    background-color: #E4B300;\r\n  }\r\n  \r\n  /* Content area */\r\n  .experience-content {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 20px;\r\n  }\r\n  \r\n  /* Vertical tabs */\r\n  .experience-vertical-tabs {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .vertical-tab {\r\n    padding: 12px;\r\n    /* border: 1px solid #73797c; */\r\n    background-color: #121827;\r\n    color: #555;\r\n    text-align: left;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .vertical-tab.selected {\r\n    background-color: #E4B300;\r\n    color: #121827;\r\n    transform: translateX(5px);\r\n  }\r\n  \r\n  .vertical-tab:hover {\r\n    background-color: #E4B300;\r\n  }\r\n  \r\n  /* Card */\r\n  .experience-card {\r\n    flex: 2;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 15px;\r\n    padding: 25px;\r\n    border-radius: 15px;\r\n    background-color: rgb(21, 21, 21);\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  }\r\n  \r\n  .experience-card:hover {\r\n    transform: scale(1.02);\r\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);\r\n  }\r\n  \r\n  .experience-card-image {\r\n    width: 100%;\r\n    max-width: 350px;\r\n    height: auto;\r\n    border-radius: 10px;\r\n    border: 2px solid #E4B300;\r\n  }\r\n  \r\n  .experience-card-title {\r\n    font-size: 24px;\r\n    color: #fff;\r\n    margin: 3px 0;\r\n  }\r\n  \r\n  .experience-card-subtitle {\r\n    font-size: 18px;\r\n    color: #555;\r\n    margin: 1px 0;\r\n  }\r\n  \r\n  .experience-card-description {\r\n    font-size: 16px;\r\n    color: #777;\r\n    text-align: center;\r\n    line-height: 1.5;\r\n  }\r\n  @media (max-width: 768px) {\r\n    .experiencecontainer1{\r\n        top: 50px;\r\n    }\r\n    .experience-content {\r\n      flex-direction: column;\r\n    }\r\n  \r\n    .experience-card {\r\n      width: 100%;\r\n    }\r\n  \r\n    .experience-card-image {\r\n      max-width: 100%;\r\n    }\r\n    .vertical-tab.selected{\r\n        transform: translateX(0);\r\n    }\r\n\r\n    .section.num2 {\r\n        height: 160vh;\r\n      }\r\n  }\r\n\r\n  /* ship background */\r\n.experiencehome{\r\n    position: relative;\r\n  }\r\n  \r\n  .experiencehome__container{\r\n    padding-top: 9.5rem;\r\n    height: 100vh;\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n     -khtml-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n  }\r\n  \r\n  .experiencehome__cloud-1,\r\n  .experiencehome__cloud-2{\r\n    position: absolute;\r\n    width: 150px;\r\n  }\r\n  \r\n  .experiencehome__cloud-1{\r\n    top:6rem;\r\n    right: 1rem;\r\n    animation: cloud-1 8s linear infinite;\r\n  }\r\n  \r\n  .experiencehome__cloud-2{\r\n    top:25rem;\r\n    left: .5rem;\r\n    animation: cloud-2 8s linear infinite;\r\n  }\r\n  \r\n  .experiencehome__images div{\r\n    max-width: initial;\r\n    width: 100%;\r\n    height: 270px;\r\n    background-size: 1000px 100%;\r\n    position: absolute;\r\n    left: 0;\r\n  }\r\n  \r\n  .experiencehome__waves-1{\r\n    bottom: -1.5rem;\r\n    animation: waves-1 4s linear infinite;\r\n  }\r\n  .experiencehome__waves-2{\r\n    bottom: -1rem;\r\n    animation: waves-2 4s linear infinite;\r\n  }\r\n  .experiencehome__waves-3{\r\n    bottom: 3rem;\r\n    animation: waves-3 4s linear infinite;\r\n  }\r\n  .experiencehome__ship{\r\n    width: 45%;\r\n    max-width: 720px;\r\n    min-width: 330px;\r\n    position: absolute;\r\n    bottom: 2rem;\r\n    left: 50;\r\n    right: 0;\r\n    margin-inline: center center;\r\n    animation: ship 2s linear infinite;\r\n  }\r\n  /* Animated Clouds */\r\n  @keyframes cloud-1{\r\n    0%{\r\n      margin-right: -1000px;\r\n    }\r\n    100%{\r\n      margin-right: 100%;\r\n    }\r\n  }\r\n  @keyframes cloud-2{\r\n    0%{\r\n      margin-left: 100%;\r\n    }\r\n    100%{\r\n      margin-left: -1000px;\r\n    }\r\n  }\r\n  \r\n  /* Animated waves */\r\n  @keyframes waves-1{\r\n    0%{\r\n      background-position: 1000px;\r\n    }\r\n    100%{\r\n      background-position: 0;\r\n    }\r\n  }\r\n  \r\n  @keyframes waves-2{\r\n    0%{\r\n      background-position: 0;\r\n    }\r\n    100%{\r\n      background-position: 1000px;\r\n    }\r\n  }\r\n  \r\n  @keyframes waves-3{\r\n    0%{\r\n      background-position: 1000px;\r\n    }\r\n    100%{\r\n      background-position: 0;\r\n    }\r\n  }\r\n  \r\n  /* Animated ship */\r\n  @keyframes ship{\r\n    0%{\r\n      transform: translateY(0) rotate(0);\r\n    }\r\n    25%{\r\n      transform: translateY(0) rotate(-8deg);\r\n    }\r\n    40%{\r\n      transform: translateY(4px) rotate(-8deg);\r\n    }\r\n    85%{\r\n      transform: translateY(1px) rotate(8deg);\r\n    }\r\n    100%{\r\n      transform: translateY(0) rotate(0);\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
